import { useTranslation } from 'libs/i18n'
import { useLocation, useNavigate } from 'libs/router'
import { PageTabs } from 'shared/components'
import { useProductSettingsTabs } from './hooks/useProductSettingsTabs'

export const ProductSettingsTabs = () => {
	const { t } = useTranslation()
	const { pathname } = useLocation()
	const navigate = useNavigate()
	const tabs = useProductSettingsTabs()

	return (
		<PageTabs
			tabs={tabs}
			activeTab={pathname}
			label={t('Products')}
			onChange={(path) => navigate(path)}
		/>
	)
}
